import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { TageService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [TageService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class TageServiceModule {}
